import React from 'react';
import { connect } from 'react-redux';
import * as formsAction from "../../redux/actions/formsAction";
import * as Actions from "../../redux/actions/loginAction";
import ControlService from '../../helper/controlservice';
import _ from 'lodash';
const uuidv4 = require('uuid/v4');

function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(formsAction.updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(formsAction.updateEditData(key, value)),
        updateFilter: (key, value, key2) => dispatch(formsAction.updateFilterData(key, value, key2)),
        updateParent: (key, value) => dispatch(formsAction.updateParentCtrData(key, value)),
        authSetToken: (data) => dispatch(Actions.authSetToken(data)),
        dataIsLoading: (bool) => dispatch(formsAction.dataIsLoading(bool)),
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    token: state.formLoginReducer.token,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});

class RadioList extends React.PureComponent {
    state = {
        apiData: [],
        isApiCalling: false,
        touched: false,
        show: true,
        uniqueid: uuidv4(),
        control: {},
        apiDataBind: []
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var apiData = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : {}
        if (nextProps.control.binddatawithmodel) {
            if (JSON.stringify(apiData[nextProps.control.bindmodelkey]) !== JSON.stringify(prevState.apiDataBind)) {
                return {
                    apiDataBind: Array.isArray(apiData[nextProps.control.bindmodelkey]) ? apiData[nextProps.control.bindmodelkey] : [],
                    control: nextProps.control,
                };
            } else if (nextProps.control != prevState.control) {
                return {
                    control: nextProps.control,
                };
            }
            else return null; // Triggers no change in the state
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { control } = this.state;
        if (control != prevState.control) {
            this.DataBind();
            this.setBindingwithothercontrols(control, this.props, this.props, true);
        } else if (control.binddatawithmodel) {
            if (!_.isEqual(this.state.apiDataBind, prevState.apiDataBind)) {
                this.DataBind(this.state.apiDataBind);
            }
        }
        var prevProp = prevProps.data[prevProps.formid];
        var currData = this.props.data[this.props.formid];
        if (prevProp && currData && prevProp[this.props.control.key] != currData[this.props.control.key]) {
            ControlService().controlVaildationCheck(this.props);
            this.setBindingwithothercontrols(this.props.control, this.props, prevProps);
        }
    }
    componentDidMount() {
        ControlService().controlVaildationCheck(this.props);
        this.DataBind(this.state.apiDataBind);
    }
    DataBind(apiData) {
        const { control, formid } = this.props;
        if (control.databind == "Server Data")
            this.ApiCall();
        else {
            let optionlist = []
            if (control.binddatawithmodel && apiData) {
                optionlist = apiData;
            } else {
                optionlist = control.optionlist;
            }
            this.setState({
                apiData: this.getData(optionlist),
                isApiCalling: false,
                IsOtherSelected: false
            }, () => this.forceUpdate());
            this.setBindingwithothercontrols(control, this.props, this.props, true);
        }
    }

    ApiCall() {
        this.setState({
            isApiCalling: true
        });
        var data = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {}
        ControlService().ServiceRequest(this.props.control.apiurl, this.props.control.optionlist, this.props.control, this.props.token, data)
            .then(res => {
                var result = [];
                if (this.props.control.responsefield) {
                    if (Array.isArray(res) && res.length > 0) {
                        res = res[0];
                    }
                    result = res ? res[this.props.control.responsefield] : [];
                } else {
                    result = res;
                }
                this.setState({
                    apiData: this.getData(result),
                    isApiCalling: false
                });
                this.setBindingwithothercontrols(this.props.control, this.props, this.props, true);
            })
            .catch(err => {

                this.setState({
                    apiData: this.getData([]),
                    isApiCalling: false
                });
                this.setBindingwithothercontrols(this.props.control, this.props, this.props, true);

                console.log(err);
            });
        //});
    }
    getData(dataoptions) {
        const { control, formid, data } = this.props;
        var _data = data[formid] ? data[formid][control.key] : "";

        var _dataoptions = dataoptions ? ControlService().deepcopy(dataoptions) : [];

        if (control.allowother && _dataoptions.length) {
            var otheroption = {};
            otheroption[control.textfield] = "Other";
            otheroption[control.valuefield] = "Other";
            _dataoptions.push(otheroption);
        }

        if (_data) {
            var option = _dataoptions.filter(x => x[control.valuefield] == _data);
            if (option.length == 0 || _data.toString().toLowerCase() == "other") {
                if (_dataoptions.find(x => x[control.textfield] == "Other")) {
                    this.setState({ IsOtherSelected: true });
                    _dataoptions.find(x => x[control.textfield] == "Other")[control.valuefield] = _data;
                }
            }
        }

        return _dataoptions;
    }
    onSelectionsChange(value, key) {
        debugger;
        var { token, control, formid } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        if (control.allowother && key !== 'OtherChange') {
            if (key == 'Other')
                this.setState({ IsOtherSelected: true })
            else
                this.setState({ IsOtherSelected: false })
        }
        let _value = data[control.key] === value ? "" : value;
        this.props.update(control.key, data[control.key] === value ? "" : value, formid);
        if (control.setdatatopagevariable) {
            const { apiData } = this.state;
            var menu = ControlService().setParam(control, _value ? apiData.find(x => x[control.valuefield] == value) : {}, ControlService().deepcopy(token.menu));
            token.menu = menu;
            this.props.authSetToken(token);
        }
        if (control.attachwithformwizard && _value) {
            this.props.update(control.formwizardkey + '_next', uuidv4(), control.formwizardcomponentformid ? (control.formwizardcomponentformid + 'write') : this.props.formid);
        }
    }
    setBindingwithothercontrols(control, props, currentProps, isInitialize) {
        if (control.bindingwithothercontrols) {
            var apiRefrshCtrls = control.bindingwithothercontrols.filter(item => item.controltype != "");
            if (control.allowbindingwithcontrols == true && apiRefrshCtrls.length > 0) {
                ControlService().RefreshBindingControls(control.key, control.bindingwithothercontrols, control.optionlist, props, currentProps, this.props.formid, isInitialize);
            }

            if (control.actiondatasource) {
                this.refreshBindingControlsFromApi(control, props);
            }
        }
    }
    refreshBindingControlsFromApi(control, props) {
        if (control.bindingwithothercontrols) {
            control.bindingwithothercontrols.forEach(_ctrl => {
                if (_ctrl.controltype == "") {
                    this.props.update(_ctrl.controlkey, '', props.formid);
                }
            });
        }
        // ...using get request
        var apiurl = "";
        apiurl = control.api;
        var data = props.data[props.formid] ? props.data[props.formid] : {};
        var apiparam = {};
        control.apiparam.forEach(option => {
            apiparam[option.key] = option.value;
        })
        if (control.bindingqueryfield) {
            apiparam[control.bindingqueryfield] = data[control.key];
        }
        if (control.actionenablerowquery) {
            apiparam.query = control.actionrawquery;
        }

        let _control = ControlService().extractControl(control, 'action');
        this.props.dataIsLoading(true);
        ControlService().ServiceRequest(apiurl, apiparam, _control, props.token, data)
            .then((res) => {
                this.props.dataIsLoading(false);
                var dataOtption = [];
                if (control.actionresponsefield) {
                    dataOtption = res ? res[control.actionresponsefield] : [];
                } else {
                    dataOtption = res;
                }

                control.bindingwithothercontrols.forEach(ctrl => {
                    if (ctrl.controltype == "") {
                        this.props.update(ctrl.controlkey, ctrl.bindingfield ? dataOtption[ctrl.bindingfield] : dataOtption, props.formid);
                    }
                });
            })
            .catch(err => {
                this.props.dataIsLoading(false);
                console.log("refreshBindingControlsFromApi-Drodown")
            });
    }
    handleBlur = () => {
        this.setState({
            touched: true,
        });
    }
    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, data[control.key]);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate ? !validate : shouldShow;
    }
    render() {
        const { control, action, formid } = this.props;
        var _data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.shouldMarkError(control, _data);
        let radioList = Array.isArray(this.state.apiData) && this.state.apiData.map((s, i) => {
            if (control.direction == 'displayImage') {
                return (
                    <React.Fragment>
                        <div key={s[control.valuefield]} className={'col-md-' + (control.noofcheckbox ? control.noofcheckbox : 'col')}>
                            <div className={'check-img ' + (control.leftimg ? ' left-img ' : ' top-img ')}>
                                <label className={"check-img-control " + (control.noimgborder ? 'border-0' : "")}>
                                    <input disabled={this.props.disabled} className="check-img-input" type="radio" name={this.state.uniqueid}
                                        aria-label={s[control.textfield]}
                                        checked={s[control.valuefield] === _data[control.key]}
                                        value={s[control.valuefield]}
                                        onClick={() => this.onSelectionsChange(s[control.valuefield], s[control.textfield])}
                                        onBlur={() => { this.handleBlur(); }} />
                                    <span className={'d-flex ' + (control.leftimg ? 'flex-row align-items-center' : 'flex-column')}>
                                        <span style={{ 'backgroundImage': 'url(' + (control.imagefield ? s[control.imagefield] : s.imageUrl) + ')', 'height': (control.imgheight ? (control.imgheight) : '40px'), 'width': (control.imgwidth ? (control.imgwidth) : '30px') }} className="check-img-img align-self-center"></span>
                                        <span className="check-img-description">
                                            <span className={"d-block mb-0i " + control.fontsize} >{s[control.textfield]}</span>
                                            {s[control.subtextfield] &&
                                                <span className="small text-muted">{s[control.subtextfield]}</span>
                                            }
                                        </span>
                                    </span>
                                    {!control.hideticmark && <span className="tic-mark"><i className="fa fa-check-circle fa-lg"></i></span>}
                                    {control.hideticmark && <span className="checkd-line"></span>}
                                </label>
                            </div>
                        </div>
                        {control.allowother &&
                            <div className={s[control.textfield] != 'Other' ? 'col col-12 d-none' : 'col col-12'} hidden={!this.state.IsOtherSelected}>
                                {s[control.textfield] == 'Other' &&
                                    <input aria-label="Other" disabled={this.props.disabled} type="text" value={_data[control.key]} className="form-control" onChange={(e) => this.onSelectionsChange(e.target.value, 'OtherChange')} placeholder="Enter Other value" />
                                }
                            </div>
                        }
                    </React.Fragment>

                )
            } else if (this.props.control.direction != 'displayImage') {
                return (
                    // <ListItem onPress={this.onSelectionsChange.bind(this, s.value)} key={s.value} style={{ marginLeft: 0, paddingLeft: 0 }}>
                    //         {data == s.value ? <Radio selected={true} /> : <Radio selected={false} />}
                    //         <Text style={{paddingLeft:10}}>{s.value}</Text>
                    // </ListItem>
                    <React.Fragment key={i}>
                        {this.props.control.direction != 'isgroupbtn' ?
                            <div key={s[control.valuefield]} className={"c-control c-radio " + (control.direction == 'horizontal' ? 'c-inline' : '')}>
                                <label>
                                    <input disabled={this.props.disabled} checked={s[control.valuefield] === _data[control.key]} className="c-control-input" type="radio" name={this.state.uniqueid} value={s[control.valuefield]}
                                        aria-label={s[control.textfield]}
                                        onClick={() => this.onSelectionsChange(s[control.valuefield], s[control.textfield])}
                                        onBlur={() => { this.handleBlur(); }} />
                                    <i className="c-control-indicator fa fa-circle-o"></i>
                                    <span className="c-control-description">
                                        {s[control.textfield]}
                                    </span>
                                </label>
                            </div>
                            :
                            <label className={"btn radio-group-btn " + (s[control.valuefield] == _data[control.key] ? 'active' : '') + ' ' + (control.groupcolor ? ('btn-' + control.groupcolor) : 'btn-outline-secondary')}>
                                <input disabled={this.props.disabled} checked={s[control.valuefield] === _data[control.key]} className="radio-group-input" type="radio" name={this.state.uniqueid} value={s[control.valuefield]}
                                    aria-label={s[control.textfield]}
                                    onClick={() => this.onSelectionsChange(s[control.valuefield], s[control.textfield])}
                                    onBlur={() => { this.handleBlur(); }} />
                                {s[control.textfield]}
                            </label>
                        }
                        {control.allowother &&
                            <div className={s[control.textfield] != 'Other' ? 'col col-12 d-none' : 'col col-12'} hidden={!this.state.IsOtherSelected}>
                                {s[control.textfield] == 'Other' &&
                                    <input aria-label="Other" disabled={this.props.disabled} type="text" value={_data[control.key]} className="form-control" onChange={(e) => this.onSelectionsChange(e.target.value, 'OtherChange')} placeholder="Enter Other value" />
                                }
                            </div>
                        }
                    </React.Fragment>

                )
            }
        });
        if (action != 'read') {
            if (this.props.control.direction == 'displayImage') {
                return (
                    <div className={control.showheader == true ? 'card mb-3' : ''}>
                        {control.showheader == true &&
                            <div className={"card-header d-flex align-items-center pointer " + (this.state.show ? '' : 'border-0')} onClick={() => this.setState({ show: !this.state.show })}>
                                {control.Panelheader &&
                                    <div>
                                        <span className="d-flex align-items-center">
                                            {_data &&
                                                <i className="text-primary fa fa-check-circle-o fa-lg pr-2"></i>
                                            }
                                            <span>{control.Panelheader}</span>
                                        </span>
                                    </div>
                                }
                                <span className="ml-auto" ><i className={"fa pl-2 " + (this.state.show ? 'fa-angle-up' : 'fa-angle-down')} aria-hidden="true"></i></span>
                            </div>
                        }
                        <div className={(control.showheader == true ? ' card-body ' : ' ') + (this.state.show ? ' ' : ' d-none ') + (!control.showheader ? ' mb-3 ' : '')}>
                            {(control.label.length > 0) &&
                                <label className={"d-block " + (_data ? 'active' : '') + " " + (control.direction == 'displayImage' ? '' : 'pb-3')}>
                                    <span>{control.label}</span>
                                    {control.require &&
                                        <sup className="text-danger font-weight-bold">*</sup>
                                    }
                                    {control.showhelptext &&
                                        <span className={"custom-tooltip"}>
                                            <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                            <span className={"tooltip tooltip-" + (control.helpdirection)}>{control.help}</span>
                                        </span>
                                    }
                                </label>
                            }
                            {control.imageurl &&
                                <img src={control.imageurl} width="100" height="100" alt={column.label} className="mb-2 img-fluid" />
                            }
                            <div className={"row check-img-outer " + (control.justifycontent) + " " + (control.alignitems)}>
                                {radioList}
                            </div>
                            {shouldMarkError &&
                                <small className="form-text text-danger">
                                    {control.errormsg ? control.errormsg : 'You must enter a ' + (control.label) + '.'}
                                </small>
                            }
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className={control.showheader == true ? 'card mb-3' : ''}>
                        {control.showheader == true &&
                            <div className={"card-header d-flex align-items-center pointer " + (this.state.show ? '' : 'border-0')} onClick={() => this.setState({ show: !this.state.show })}>
                                {control.Panelheader &&
                                    <div>
                                        <span className="d-flex align-items-center">
                                            {_data &&
                                                <i className="text-primary fa fa-check-circle-o fa-lg pr-2"></i>
                                            }
                                            <span>{control.Panelheader}</span>
                                        </span>
                                    </div>
                                }
                                <span className="ml-auto" ><i className={"fa pl-2 " + (this.state.show ? 'fa-angle-up' : 'fa-angle-down')} aria-hidden="true"></i></span>
                            </div>
                        }
                        <div className={(control.showheader == true ? ' card-body ' : ' ') + (this.state.show ? ' ' : ' d-none ') + (!control.showheader ? ' mb-3 ' : '')}>
                            {(control.label.length > 0) &&
                                <label className={"d-block " + (_data ? 'active' : '')}>
                                    <span>{control.label}</span>
                                    {control.require &&
                                        <sup className="text-danger font-weight-bold">*</sup>
                                    }
                                    {control.showhelptext &&
                                        <span className={"custom-tooltip"}>
                                            <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                            <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                                        </span>
                                    }
                                </label>
                            }
                            {control.imageurl &&
                                <img src={control.imageurl} width="100" height="100" alt={column.label} className="mb-2 img-fluid" />
                            }
                            {
                                this.props.control.direction != 'isgroupbtn' ?
                                    <React.Fragment>
                                        {radioList}
                                    </React.Fragment>
                                    :
                                    <div className="btn-group radio-group flex-wrap">
                                        {radioList}
                                    </div>
                            }
                            {shouldMarkError &&
                                <small className="form-text text-danger">
                                    {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                                </small>
                            }
                        </div>
                    </div>
                );
            }
        }
        else {
            return (
                <div>
                    <label>{control.label}</label>
                    <div>{_data[control.key]}</div>
                </div>
                // <View>
                //     <Text style={styles.listHading} >{control.label}</Text>
                //     <Text>{data}</Text>
                // </View>
            );
        }
    }
}

export default connect(
    mapStateToProps, bindAction
)(RadioList);